module.exports = __webpack_public_path__ + "static/newborn-c63e3cabdc040a8174a825a5045c4634.png";